import { useEffect, useState, useCallback } from 'react'
import { Field, Label, Control, InlineWrapper, StepFormWrapper } from '../../styles/login.style'
import { DropzoneContainer } from '../../styles/upload-dialog.style'
import Dropzone, { FileRejection } from 'react-dropzone'
import { X } from 'react-bootstrap-icons'
import { registrationData, ProfilePatch } from '../../hooks/auth.service'
import { useFileUpload } from '../../hooks/useFileUpload'
import { useToast } from '../../contextManager/toast.context'

const CV_MAX_BYTES = 4 * 1024 * 1024 // 4MB — Vercel serverless body limit is ~4.5MB total

interface Props {
    data: ProfilePatch
    onChange: (d: ProfilePatch) => void
    onValidityChange: (ok: boolean) => void
  }

  export default function CVStep({
    data,
    onChange,
    onValidityChange,
  }: Props) {

    // const { uploadFile, isLoading } = useFileUpload();         // ← add
    const { addToast } = useToast()

    const {
      CVFile,
    } = data

    const [CVName, setCVName] = useState(CVFile?.name || '')

    const onDrop = useCallback(
      (files: File[], rejections: FileRejection[]) => {
        if (rejections.length > 0) {
          const r = rejections[0]
          const tooBig = r.errors.some((e) => e.code === 'file-too-large')
          const wrongType = r.errors.some((e) => e.code === 'file-invalid-type')
          const mb = (r.file.size / (1024 * 1024)).toFixed(1)
          addToast({
            variant: 'error',
            title: tooBig
              ? `CV is too large (${mb} MB). Max size is 4 MB — try compressing the PDF.`
              : wrongType
              ? 'CV must be a PDF file.'
              : r.errors[0]?.message || 'File rejected.',
          })
          return
        }
        if (!files[0]) return
        setCVName(files[0].name)
        onChange({ ...data, CVFile: files[0] })
      },
      [data, onChange, addToast]
    )
  
    const removeFile = () => {
      setCVName('')
      onChange({ ...data, CVFile: undefined })
    }
  
    const isOK = true;
  
    useEffect(() => onValidityChange(isOK), [isOK, onValidityChange])
  


return (
<StepFormWrapper>
  <Field name="CV" css={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
        {/* <InlineWrapper> */}
        <Label>Upload CV (pdf)</Label>
        <div style={{ position: 'relative', width: '100%' }}>
          <Dropzone
            onDrop={onDrop}
            accept={{ 'application/pdf': []}}
            maxFiles={1}
            maxSize={CV_MAX_BYTES}
          >
            {({ getRootProps, getInputProps, isDragActive }) => (
              <DropzoneContainer
                {...getRootProps()}
                state={CVFile ? 'success' : 'idle'}
                css={{
                  cursor: 'pointer',
                  background: isDragActive
                    ? '$elementBackgroundHover'
                    : '$elementBackground',
                  mb: '0.5rem',
                }}
              >
                <input {...getInputProps()} />
                {CVName ? (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      width: '100%',
                    }}
                  >
                    <span>{CVName}</span>
                    <X
                      size={18}
                      style={{ cursor: 'pointer' }}
                      onClick={(e) => {
                        e.stopPropagation()
                        removeFile()
                      }}
                    />
                  </div>
                ) : (
                  <p style={{ margin: 0 }}>
                    Drag PDF here or click to select
                  </p>
                )}
              </DropzoneContainer>
            )}
          </Dropzone>
          {CVName && (
            <small style={{ fontSize: '0.8rem' }}>
              Selected: {CVName}
            </small>
          )}
        {/* </InlineWrapper> */}
        </div>
      </Field>
      </StepFormWrapper>
)
}